import React from 'react'
import {useStyles} from './SchemaStyle'
export default function Schema() {
    const style=useStyles()
    return (
        <div style={{minHeight:"57vh"}}>
            <div className={style.schemaText}>
            This Service has schema registry API disabled. Enable Schema Registry API
            </div>
        </div>
    )
}
